import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { FirebaseFirestoreService } from '../../services/firebase-firestore.service';
import { FirebaseUsageStats } from '../../services/firebase.model';
import { DecimalPipe } from '@angular/common';
import { CountUp, CountUpOptions } from 'countup.js';
import * as numbro from 'numbro';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-home-current-stats',
  standalone: true,
  imports: [TooltipModule, DecimalPipe],
  templateUrl: './home-current-stats.component.html',
  styleUrl: './home-current-stats.component.scss',
  providers: [DecimalPipe]
})
export class HomeCurrentStatsComponent implements AfterViewInit {
  stats: FirebaseUsageStats
  lastUpdatedMinutes: number

  baseCountUpOptions: CountUpOptions = {
    enableScrollSpy: true,
    scrollSpyOnce: false,
    formattingFn: (n: number): string => {
      return (numbro as any).default(n).format({ average: true, mantissa: 2, spaceSeparated: true }).toUpperCase();
    }
  }

  constructor(
    private firestoreService: FirebaseFirestoreService,
  ){
  }

  getMinuteDifference(date1: Date, date2: Date): number {
    const timeDifferenceMs = Math.abs(date2.getTime() - date1.getTime());
    const minuteDifference = Math.floor(timeDifferenceMs / (60 * 1000));
    return minuteDifference;
  }

  ngAfterViewInit(): void {
    this.firestoreService.getCurrentUsageStats().then(x => {
      this.stats = x
      this.lastUpdatedMinutes = this.getMinuteDifference(new Date(), new Date(x.timeStamp))
      const visitsCountup = new CountUp("visits", x.totalVisits, this.baseCountUpOptions)
      visitsCountup.start()

      const favoritesCountup = new CountUp("favorites", x.totalFavorites, this.baseCountUpOptions)
      favoritesCountup.start()

      const activePlayersCountup = new CountUp("active-players", x.totalActivePlayers, this.baseCountUpOptions)
      activePlayersCountup.start()
    })
  }
}
